module.exports = __webpack_public_path__ + "img/baerengasse.ba7fe8ca.jpg";